import React, {useContext, useEffect, useState} from 'react';

import TeaserTopItem from '~/src/components/teaser/top/item/TeaserTopItem';

import {getPopularItems, SortBy} from '~/src/utilities/helpers/popularity';
import {createTopItemTracker} from '~/src/utilities/tracking/gtm';
import {GtmEvents} from '~/src/utilities/constants/tracking';
import initPolyglot from '~/src/utilities/libs/polyglot';
import PageContext from '~/src/components/context/PageContext';

import css from './TeaserTopCommented.module.scss';
import i18n from './TeaserTopCommented.i18n.json';

const getTranslation = initPolyglot(i18n);

interface Props {
    size?: number;
    className?: string;
}

const shouldFetchData = () => window.matchMedia(`(min-width: ${css.breakpointDesktop})`).matches;

const TeaserTopCommented = ({size = 5, className}: Props) => {
    const {gtmPageType} = useContext(PageContext);

    const [teasers, setTeasers] = useState(new Array(size).fill(null));
    const [fetchData, setFetchData] = useState(process.browser && shouldFetchData());

    if (process.browser) {
        useEffect(() => {
            if (fetchData) {
                getPopularItems({sortBy: SortBy.COMMENTS, limit: size}).then((data) => {
                    if (data) {
                        setTeasers(data);
                    }
                });
            } else {
                const onResize = () => setFetchData(shouldFetchData());

                window.addEventListener('resize', onResize);
                return () => window.removeEventListener('resize', onResize);
            }
        }, [fetchData]);
    }

    return (
        <article className={[className, css.container].join(' ')}>
            <header className={css.header}>
                <h2 className={css.title}>{getTranslation('title')}</h2>
                <span className={css.subtitle}>{getTranslation('subtitle')}</span>
            </header>
            <section className={css.teasers}>
                {teasers.map((teaser, index) => {
                    return (
                        <TeaserTopItem
                            key={index}
                            {...teaser}
                            className={css.teaser}
                            onClick={createTopItemTracker(GtmEvents.WIDGET_MOST_COMMENTED, gtmPageType, teaser?.url?.substr(-12) || '', index, teaser?.title)}
                        />
                    );
                })}
            </section>
        </article>
    );
};

export default TeaserTopCommented;
